type Organization = {
  id: string;
  name: string;
}

export const shouldUserSelectOrg = (
  currentOrganization: Organization, organizations: Organization[],
): boolean => organizations.length > 0 && !currentOrganization;
